import "../../index20.css";
import { jsxs as i, jsx as c } from "react/jsx-runtime";
import { useCallback as P } from "react";
import { _ as n } from "../../cs-piwRuCFZ.js";
import "../../type-BFTbooL7.js";
import E from "../InputError/index.js";
import F from "./Checkmark/index.js";
const I = "_checkbox_12g7n_1", L = "_with-background_12g7n_7", T = "_checkmark-container_12g7n_12", $ = "_input_12g7n_18", q = "_content_12g7n_33", z = "_description_12g7n_40", A = "_checked_12g7n_45", D = "_checkmark_12g7n_12", G = "_disabled-checkbox_12g7n_58", e = {
  checkbox: I,
  withBackground: L,
  checkmarkContainer: T,
  input: $,
  content: q,
  description: z,
  checked: A,
  checkmark: D,
  disabledCheckbox: G
};
function U(b) {
  const {
    className: u,
    checkmark: g = F,
    checkmarkClassName: C,
    checkmarkContainerClassName: x,
    disabled: k,
    error: d,
    indeterminate: h,
    inputClassName: N,
    invertedLogic: a = !1,
    label: o,
    labelContainerClassName: f,
    name: l,
    onChange: m,
    readOnly: t,
    tooltip: v,
    value: _,
    description: r,
    withBackground: w,
    ...y
  } = b, B = P(
    (O) => {
      const p = O.currentTarget.checked;
      m(
        a ? !p : p,
        l
      );
    },
    [l, m, a]
  ), s = a ? !_ : _, j = n(
    e.checkbox,
    u,
    !h && s && e.checked,
    w && e.withBackground,
    k && e.disabledCheckbox,
    t && e.readOnly
  );
  return /* @__PURE__ */ i(
    "label",
    {
      className: j,
      title: v,
      children: [
        /* @__PURE__ */ i("div", { className: n(e.checkmarkContainer, x), children: [
          /* @__PURE__ */ c(
            "input",
            {
              onChange: B,
              className: n(e.input, N),
              type: "checkbox",
              checked: s ?? !1,
              disabled: k || t,
              readOnly: t,
              ...y
            }
          ),
          /* @__PURE__ */ c(
            g,
            {
              className: n(e.checkmark, C),
              value: s ?? !1,
              indeterminate: h,
              "aria-hidden": "true"
            }
          )
        ] }),
        (o || r) && /* @__PURE__ */ i("div", { className: e.content, children: [
          o && /* @__PURE__ */ c("div", { className: f, children: o }),
          r && /* @__PURE__ */ c("div", { className: e.description, children: r })
        ] }),
        d && /* @__PURE__ */ c(E, { children: d })
      ]
    }
  );
}
export {
  U as default
};
